import type { Page as PageType } from 'src/types/page';
import { ProjectsPage } from 'src/sections/projects/projects-page';

const Page: PageType = () => <ProjectsPage />;

export default Page;
